export default "__VITE_ASSET__Cs0A4zJi__"